import { AddressProps } from '@/models/Address';
import { CountryProps } from '@/models/Country';
import { CountyProps } from '@/models/County';
import { StateProps } from '@/models/State';

export const getCountyByCountyId = (
  counties: CountyProps[],
  countyId: string,
  stateId: string
): CountyProps | null => {
  return (
    counties.find((county: CountyProps) => county.id === countyId && county.stateId === stateId) ??
    null
  );
};

export const getStateByStateId = (states: StateProps[], stateId: string): StateProps | null => {
  return states.find((state: StateProps) => state.id === stateId) ?? null;
};

export const getCountryByCountryId = (
  countries: CountryProps[],
  countryId: number
): CountryProps | null => {
  return countries.find((country: CountryProps) => country.id === countryId) ?? null;
};

export const getCountryIdByCountryName = (
  countries: CountryProps[],
  countryName: string
): number | null => {
  const country = countries.find((ctry: CountryProps) => ctry.name === countryName);
  return country ? Number(country.id) : null;
};

export const singleLineAddress = (address: AddressProps, stateName: string): string => {
  return `${address.streetAddress1}, ${address.city}, ${stateName} ${address.zipCode}`;
};
